import React from "react";

const AboutIntroSection = ({ data }) => (

    <section className="about-hero">

        <div className="about-container">

            <div className="about-hero-content">

                <div className="about-eyebrow">
                    {data.eyebrow}
                </div>

                <h1>
                    {data.title}
                    {data.highlight && (
                        <>
                            {" "}
                            <span>{data.highlight}</span>
                        </>
                    )}
                </h1>

                {(data.paragraphs || []).map(
                    (paragraph, i) => (
                        <p key={i}>
                            {paragraph}
                        </p>
                    )
                )}

                {data.buttons && (
                    <div className="about-buttons">

                        {data.buttons.primary && (
                            <a
                                href={data.buttons.primary.url}
                                className="about-btn about-btn-primary"
                            >
                                {data.buttons.primary.label}
                            </a>
                        )}

                        {data.buttons.secondary && (
                            <a
                                href={data.buttons.secondary.url}
                                className="about-btn about-btn-outline"
                            >
                                {data.buttons.secondary.label}
                            </a>
                        )}

                    </div>
                )}

            </div>

        </div>

    </section>
);

export default AboutIntroSection;